import { writable } from "svelte/store";

const initialState = {
  supported: false,
  registrationFound: false,
  waiting: false,
  updateAvailable: false,
  installing: false,
  controllerPresent: false,
  applying: false,
  error: "",
  cacheName: "",
  cacheNumber: "",
};

export const serviceWorkerUpdate = writable(initialState);

let currentState = initialState;
let bridgeInitialized = false;

serviceWorkerUpdate.subscribe(function (value) {
  currentState = value;
});

function pushState(nextState) {
  serviceWorkerUpdate.set(
    Object.assign({}, initialState, currentState, nextState || {})
  );
}

function syncFromWindow(detail) {
  if (!detail || typeof detail !== "object") {
    return;
  }
  pushState(detail);
}

function waitForInstalledWorker(registration) {
  return new Promise(function (resolve) {
    var installingWorker = registration && registration.installing;
    if (!installingWorker) {
      resolve(null);
      return;
    }

    installingWorker.addEventListener("statechange", function () {
      if (installingWorker.state === "installed") {
        resolve(registration.waiting || installingWorker);
      }
      if (installingWorker.state === "redundant") {
        resolve(null);
      }
    });
  });
}

function initializeBridge() {
  if (bridgeInitialized || typeof window === "undefined") {
    return;
  }

  bridgeInitialized = true;
  syncFromWindow(window.__VECTOR_SW_UPDATE__);

  window.addEventListener("vector-sw-update", function (event) {
    syncFromWindow(event.detail);
  });
}

initializeBridge();

export function getKnownServiceWorkerCacheNumber() {
  initializeBridge();

  if (typeof currentState.cacheNumber === "string" && currentState.cacheNumber !== "") {
    return currentState.cacheNumber;
  }

  if (typeof window === "undefined") {
    return "";
  }

  if (
    window.__VECTOR_SW_UPDATE__ &&
    typeof window.__VECTOR_SW_UPDATE__.cacheNumber === "string" &&
    window.__VECTOR_SW_UPDATE__.cacheNumber !== ""
  ) {
    return window.__VECTOR_SW_UPDATE__.cacheNumber;
  }

  try {
    return sessionStorage.getItem("vector_sw_cache_number") || "";
  } catch (error) {
    return "";
  }
}

export async function applyServiceWorkerUpdate() {
  initializeBridge();

  if (!("serviceWorker" in navigator)) {
    pushState({ supported: false, applying: false });
    return false;
  }

  pushState({ applying: true, error: "" });

  try {
    var registration = await navigator.serviceWorker.getRegistration("/sw.js");

    if (!registration) {
      pushState({ applying: false });
      return false;
    }

    var waitingWorker = registration.waiting;

    if (!waitingWorker) {
      await registration.update();
      waitingWorker = registration.waiting || (await waitForInstalledWorker(registration));
    }

    if (!waitingWorker || typeof waitingWorker.postMessage !== "function") {
      pushState({ applying: false, waiting: false, updateAvailable: false });
      return false;
    }

    await new Promise(function (resolve) {
      var resolved = false;

      function finish() {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve();
      }

      navigator.serviceWorker.addEventListener(
        "controllerchange",
        function () {
          finish();
        },
        { once: true }
      );

      waitingWorker.postMessage({ type: "SKIP_WAITING" });

      setTimeout(function () {
        finish();
      }, 10000);
    });

    window.location.reload();
    return true;
  } catch (error) {
    pushState({
      applying: false,
      error: String(error && error.message ? error.message : error),
    });
    return false;
  }
}